/**
 * Security Utility Module
 * Provides DOM sanitization, HTML escaping, and input sanitization
 * to protect against XSS (Cross-Site Scripting) attacks.
 */

/**
 * Escapes special HTML characters in a string to prevent XSS injection.
 * @param {string} str - Raw input text
 * @returns {string} - Escaped safe HTML string
 */
export function escapeHTML(str) {
  if (str === null || str === undefined) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

/**
 * Sanitizes arbitrary text by stripping tags and escaping characters.
 * @param {string} text - Input string
 * @returns {string} - Cleaned plain text
 */
export function sanitizeText(text) {
  if (!text) return '';
  const escaped = escapeHTML(text);
  return escaped.replace(/javascript:/gi, '').trim();
}

/**
 * Validates and sanitizes HTTP/HTTPS URLs.
 * @param {string} url - Input URL string
 * @returns {string|null} - Sanitized URL or null if invalid/dangerous
 */
export function sanitizeURL(url) {
  if (!url) return null;
  try {
    const parsed = new URL(url.trim());
    if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
      return parsed.href;
    }
  } catch (e) {
    // Invalid URL format
  }
  return null;
}
